import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TagColored } from 'uiToolkitV1/Tag';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import ColoredNullValueComponent from './ColoredNullValueComponent';

const valueColors = {
  // Hex color not working
  Completed: { color: 'green' },
  Scheduled: { color: 'grey' },
  'Not setup': { color: 'red' },
  Archived: { color: 'grey' },
};

const ColoredTagComponent = ({ value }) => {
  const isString = typeof value === 'string';

  if (!isString && value !== null) {
    const percentageColor = value > 50 ? '#44812F' : '#B96400';
    return <TextBodyMedium color={percentageColor}>{value}%</TextBodyMedium>;
  }

  if (value in valueColors) {
    const tagColor = valueColors[value].color;
    return <TagColored color={tagColor}>{value}</TagColored>;
  }

  return <ColoredNullValueComponent />;
};

const ParticipationPercentage = ({ value }) => (
  <Flex w="100%" h="100%" alignItems="center">
    <ColoredTagComponent value={value} />
  </Flex>
);

export { ParticipationPercentage };
